// import { Link } from "react-router-dom";
import WeatherImg from "../assets/weather.jpg"
import TodoImg from "../assets/todo2.jpg"
import LoginImg from "../assets/login2.jpg"
import MovieImg from "../assets/movie3.jpg"
import CalcImg from "../assets/calc.jpg"
import NPMImg from "../assets/npm.jpg"
import PayapiImg from "../assets/payapi.jpg"
import BlogImg from "../assets/myblog.jpg"
import QuranAppImg from "../assets/quran-app.jpg"

function Portfolio() {
    return (
        <div className="portfolio container general-margin_top">
            <h1 className="text-center portfolio-title">Welcome to my work</h1>

            {/* <Link className="btn btn-outline-info back-btn" to="/"> ← Back </Link> */}
            <ul className="portfolio-list d-flex justify-content-between flex-wrap">
                <li className="portfolio-item rounded mb-5">
                    <a href="https://my-weather-program.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={WeatherImg} alt="weather app" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Weather app</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://my-weather-program.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/js-weather-app" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://todo-final.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={TodoImg} alt="todo app" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">To do app</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://todo-final.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/todo-intern" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://holy-quran-app.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={QuranAppImg} alt="pixer site" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Quran App</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://holy-quran-app.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/Quran-App" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://exam5-react-abbos.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={LoginImg} alt="Authorization app" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Authorization,<br />Posts render</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://exam5-react-abbos.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/js-weather-app" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://movie-render-final.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={MovieImg} alt="movie app" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Movies</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://movie-render-final.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/movie-render-final" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://my-nice-calculator.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={CalcImg} alt="calc app" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Calculator</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://my-nice-calculator.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/calculator" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://www.npmjs.com/package/find-longest-word" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={NPMImg} alt="MPM package" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">NPM package</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://www.npmjs.com/package/find-longest-word" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/npm-longest-word-package" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://payapi-design-ash.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={PayapiImg} alt="payapi site" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Payapi site</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://payapi-design-ash.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/Payapi-exam-design" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>

                <li className="portfolio-item rounded mb-5">
                    <a href="https://mybloggg.netlify.app/" target="_blank" rel="noopener noreferrer">
                        <img className="rounded" src={BlogImg} alt="blog site" width={300} />
                    </a>
                    <h4 className="text-center mt-3 mb-3 weather-title">Blog site</h4>
                    <div className="d-flex justify-content-between p-4">
                        <a className="weather-link" href="https://mybloggg.netlify.app/" target="_blank" rel="noopener noreferrer">Link to site</a>
                        <a className="weather-link" href="https://github.com/Shamsiddinov70/my-blog-new-version" target="_blank" rel="noopener noreferrer">Source code</a>
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default Portfolio;
